import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import API from '@resi-media/api-types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@mediaId/download`,
    params: {} as { mediaId: string },
    request: {} as API.Central.V3.ContentDestinations.Post.Download.Request,
    responseSchema: API.Central.V3.ContentDestinations.Post.Download,
    method: HTTP_METHODS.POST,
  },
};

export const id = {};
